import React from 'react';
import OverviewDashboard from "./OverviewDashboard";

// Everyone lands on the Overview. The backend serves it company-wide to admins
// and scoped to the signed-in member's own data to everyone else.
const Dashboard = () => <OverviewDashboard />;

export default Dashboard;
